import { $userIdentity } from './states';
import { fetchUserIdentity } from './effects';

// Fetch user identity
$userIdentity.on(fetchUserIdentity.doneData, (_, data) => data);
